export function canAccessModule({
  isSuperAdmin = false,
  moduleAccessPermissions = {},
  dataAccessPermissions = {},
  requiredPermission = '',
  dataAccessPath = '',
}) {
  if (isSuperAdmin) return true;

  const hasModulePermission =
    !requiredPermission || Boolean(moduleAccessPermissions?.[requiredPermission]);

  const dataPermission = dataAccessPath ? dataAccessPermissions?.[dataAccessPath] : undefined;
  const hasDataPermission = dataPermission !== false && dataPermission !== 0;

  return hasModulePermission && hasDataPermission;
}

export default canAccessModule;
